module.exports = __webpack_public_path__ + "img/Ardunic Elements-24.1ae59f2d.svg";